import { configureStore } from '@reduxjs/toolkit'
import usuarioSlice from './reducers/UsuarioLogado'
import filialSlice from './reducers/FilialLogada'
import nomeFilial from './reducers/FilialLogada'
import empresaSlice from './reducers/EmpresaLogada'

const store = configureStore({
    reducer: {
        nameUser: usuarioSlice,
        filialOn: filialSlice,
        nomeFilial: nomeFilial,
        empresaOn: empresaSlice,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export default store;